import styles from "./page_apply.module.scss";
import ApplyForm from "./ApplyForm";
import React from "react";
import {useSearchParams} from "react-router-dom";

export default function PageApply(){
    const [searchParams] = useSearchParams();
    const code = searchParams.get("code");
    const defaultInviteCode = code ? code : undefined;

    return(
        <div className={styles.content}>
            <div>
                <div className={styles.left}>
                    <h2>申请试用</h2>
                    <p>免费试用并了解更多关于烯牛数据的产品和服务，请填写您的个人信息，我们会尽快回复
                        <br />
                        提交申请将会电话审核，虚假信息不予通过。如有问题可联系
                        <span>烯牛客服</span></p>
                </div>
                <div className={styles.right}>
                    <ApplyForm key={defaultInviteCode ?? "default"} onClose={null} defaultInviteCode={defaultInviteCode}/>
                </div>
            </div>
        </div>
    )
}
